module.exports = __webpack_public_path__ + "static/media/message01.92959bad.png";